import type { ReactNode } from 'react';
import { Icon } from '../icons';
import { useUiT } from '../i18n';
import { registerPrimitiveMessages, statesDe, statesEn } from '../i18n/primitives';
import { cx } from './cx';
import '../styles/primitives/states.css';

registerPrimitiveMessages(statesEn, statesDe);

export type NotFoundProps = {
  title?: ReactNode;
  description?: ReactNode;
  /** The way back (a link to the list, Home). */
  action?: ReactNode;
  compact?: boolean;
  className?: string;
};

/** One not-found state for pages, records and artefacts, inside the shell. */
export function NotFound({ title, description, action, compact, className }: NotFoundProps) {
  const t = useUiT();
  return (
    <div className={cx('state', compact && 'compact', className)} role="status">
      <span className="state-icon" aria-hidden="true">
        <Icon name="search" size={compact ? 16 : 20} />
      </span>
      <h2 className="state-title">{title ?? t('ui.notFound.title')}</h2>
      <div className="state-text">{description ?? t('ui.notFound.body')}</div>
      {action ? <div className="state-actions">{action}</div> : null}
    </div>
  );
}
